import React, { Component, Fragment } from "react";
import { Link } from "react-router";
import { legacy_connect as connect } from "react-redux";
import { bindActionCreators } from "redux";
import { ActionCreator } from "actions";
import "containers/GameNavigation/styles.scss";
import { ReactComponent as ScratchCardsIcon } from "assets/icons/scratch cards.svg";
import { ReactComponent as SlotIconActive } from "assets/icons/Slots-active.svg";
import { ReactComponent as SlotIconInactive } from "assets/icons/Slots-inactive.svg";
import { ReactComponent as TableGamesIconActive } from "assets/icons/TableGames-active.svg";
import { ReactComponent as TableGamesIconInactive } from "assets/icons/TableGames-inactive.svg";
import { ReactComponent as VirtualSportsIconActive } from "assets/icons/VirtualSports-active.svg";
import { ReactComponent as VirtualSportsIconInactive } from "assets/icons/VirtualSports-inactive.svg";
import { ReactComponent as CrashGamesIconActive } from "assets/icons/CrashGames-active.svg";
import { ReactComponent as CrashGamesIconInactive } from "assets/icons/CrashGames-inactive.svg";
import { ReactComponent as LiveCasinoIconActive } from "assets/icons/LiveCasino-active.svg";
import { ReactComponent as LiveCasinoIconInactive } from "assets/icons/LiveCasino-inactive.svg";
import { ReactComponent as InstantWinIconActive } from "assets/icons/InstantWin-active.svg";
import { ReactComponent as InstantWinIconInactive } from "assets/icons/InstantWin-inactive.svg";
import { ReactComponent as LotteryIconActive } from "assets/icons/Lottery-active.svg";
import { ReactComponent as LotteryIconInactive } from "assets/icons/Lottery-inactive.svg";
import { ReactComponent as ShootingIconActive } from "assets/icons/Shooting-active.svg";
import { ReactComponent as ShootingIconInactive } from "assets/icons/Shooting-inactive.svg";
import { ReactComponent as GameShowsIconActive } from "assets/icons/GameShows-active.svg";
import { ReactComponent as GameShowsIconInactive } from "assets/icons/GameShows-inactive.svg";
import { ReactComponent as EsportsIconActive } from "assets/icons/ESports-active.svg";
import { ReactComponent as EsportsIconInactive } from "assets/icons/Esports-inactive.svg";
import { ReactComponent as DiscoverIconActive } from "assets/icons/Discover-active.svg";
import { ReactComponent as DiscoverIconInactive } from "assets/icons/Discover-inactive.svg";
import { ReactComponent as SportsIconActive } from "assets/icons/Sports-active.svg";
import { ReactComponent as SportsIconInactive } from "assets/icons/Sports-inactive.svg";
import { HomeIcon, BingoIcon, VirtualGamesIcon } from "component/icons";
import MainNavigationSkeleton from "component/listItemSkeleton/MainNavigationSkeleton";

import { isEmpty } from "lodash";
import HeaderBannerDefault from "assets/images/headerBannerDefault.png";
import SportsBanner from "assets/images/Sports.png";
import { setDefaultImageFormat } from "utils/image";
import ScrollDirectionTracker from "utils/ScrollDirectionTracker.js";

class GameNavigation extends Component {
  constructor(props) {
    super(props);
    this.setBannerSrc = this._setBannerSrc.bind(this);
    this.getIcon = this._getIcon.bind(this);
    this.sentinelRef = React.createRef();
    this.state = {
      showMenu: false,
      isStuck: false,
      isNavHidden: false,
      iconSize: {
        width: 0,
        height: 0,
      },
    };

    this.scrollTracker = new ScrollDirectionTracker({
      scrollContainerSelector: ".main-content",
      threshold: 8,
      topOffset: 20,
      onChange: (isHidden) => this.setState({ isNavHidden: isHidden }),
    });
  }

  componentDidMount() {
    if (this.sentinelRef.current) {
      this.observer = new IntersectionObserver(
        ([entry]) => {
          this.setState({ isStuck: !entry.isIntersecting });
        },
        {
          threshold: 0,
          rootMargin: "-40px 0px 0px 0px",
        },
      );
      this.observer.observe(this.sentinelRef.current);
    }

    if (this.props.isMobile) {
      this.scrollTracker.start();
    }
  }

  componentWillUnmount() {
    if (this.observer) {
      this.observer.disconnect();
    }
    this.scrollTracker.stop();
  }

  _setBannerSrc(match) {
    let bannerUrl;
    switch (match.params.page) {
      case "wl-slots":
        bannerUrl = () => {
          try {
            return `${setDefaultImageFormat(
              this.props.gameLobbyBannerUrls.getIn(["SLOT_GAMES"]),
              this.props.imageFormat.get("gamelobbyBanner"),
            )}`;
          } catch (err) {
            return HeaderBannerDefault;
          }
        };
        break;
      case "wl-tableGames":
        bannerUrl = () => {
          try {
            return `${setDefaultImageFormat(
              this.props.gameLobbyBannerUrls.getIn(["TABLE_GAMES"]),
              this.props.imageFormat.get("gamelobbyBanner"),
            )}`;
          } catch (err) {
            return HeaderBannerDefault;
          }
        };
        break;
      case "wl-instantWinGames":
        bannerUrl = () => {
          try {
            return `${setDefaultImageFormat(
              this.props.gameLobbyBannerUrls.getIn(["INSTANT_WIN"]),
              this.props.imageFormat.get("gamelobbyBanner"),
            )}`;
          } catch (err) {
            return HeaderBannerDefault;
          }
        };
        break;
      case "wl-virtualSportsGames":
        bannerUrl = () => {
          try {
            return `${setDefaultImageFormat(
              this.props.gameLobbyBannerUrls.getIn(["VIRTUAL_SPORTS"]),
              this.props.imageFormat.get("gamelobbyBanner"),
            )}`;
          } catch (err) {
            return HeaderBannerDefault;
          }
        };
        break;
      case "wl-virtualGameGames":
        bannerUrl = () => {
          return HeaderBannerDefault;
        };
        break;
      case "wl-scratchCardGames":
        bannerUrl = () => {
          try {
            return `${setDefaultImageFormat(
              this.props.gameLobbyBannerUrls.getIn(["SCRATCH_CARDS"]),
              this.props.imageFormat.get("gamelobbyBanner"),
            )}`;
          } catch (err) {
            return HeaderBannerDefault;
          }
        };
        break;
      case "wl-bingoGames":
        bannerUrl = () => {
          try {
            return `${setDefaultImageFormat(
              this.props.gameLobbyBannerUrls.getIn(["BINGO_GAMES"]),
              this.props.imageFormat.get("gamelobbyBanner"),
            )}`;
          } catch (err) {
            return HeaderBannerDefault;
          }
        };
        break;
      case "wl-shootingGames":
        bannerUrl = () => {
          try {
            return `${setDefaultImageFormat(
              this.props.gameLobbyBannerUrls.getIn(["SHOOTING_GAMES"]),
              this.props.imageFormat.get("gamelobbyBanner"),
            )}`;
          } catch (err) {
            return HeaderBannerDefault;
          }
        };
        break;
      case "wl-liveCasinoGames":
        bannerUrl = () => {
          try {
            return `${setDefaultImageFormat(
              this.props.gameLobbyBannerUrls.getIn(["LIVE_CASINO"]),
              this.props.imageFormat.get("gamelobbyBanner"),
            )}`;
          } catch (err) {
            return HeaderBannerDefault;
          }
        };
        break;
      case "wl-esportsGames":
        bannerUrl = () => {
          try {
            return `${setDefaultImageFormat(
              this.props.gameLobbyBannerUrls.getIn(["ESPORTS"]),
              this.props.imageFormat.get("gamelobbyBanner"),
            )}`;
          } catch (err) {
            return HeaderBannerDefault;
          }
        };
        break;
      case "wl-lotteryGames":
        bannerUrl = () => {
          try {
            return `${setDefaultImageFormat(
              this.props.gameLobbyBannerUrls.getIn(["LOTTERY"]),
              this.props.imageFormat.get("gamelobbyBanner"),
            )}`;
          } catch (err) {
            return HeaderBannerDefault;
          }
        };
        break;
      case "wl-CRASH":
        bannerUrl = () => {
          try {
            return `${setDefaultImageFormat(
              this.props.gameLobbyBannerUrls.getIn(["CRASH"]),
              this.props.imageFormat.get("gamelobbyBanner"),
            )}`;
          } catch (err) {
            return HeaderBannerDefault;
          }
        };
        break;
      case "wl-GAME_SHOW":
        bannerUrl = () => {
          try {
            return `${setDefaultImageFormat(
              this.props.gameLobbyBannerUrls.getIn(["GAME_SHOW"]),
              this.props.imageFormat.get("gamelobbyBanner"),
            )}`;
          } catch (err) {
            return HeaderBannerDefault;
          }
        };
        break;
      case "wl-SPORTS":
        bannerUrl = () => {
          try {
            return SportsBanner;
          } catch (err) {
            return HeaderBannerDefault;
          }
        };
        break;
      default:
        bannerUrl = () => {
          try {
            return `${setDefaultImageFormat(
              this.props.gameLobbyBannerUrls.getIn(["MY_CASINO"]),
              this.props.imageFormat.get("gamelobbyBanner"),
            )}`;
          } catch (err) {
            return HeaderBannerDefault;
          }
        };
        break;
    }
    return bannerUrl();
  }

  _getIcon(content, key) {
    let isActive = this.props.match.params.page === content.get("rel");
    let Icon;

    switch (content.get("rel")) {
      case "wl-slots":
        Icon = isActive ? SlotIconActive : SlotIconInactive;
        break;
      case "wl-tableGames":
        Icon = isActive ? TableGamesIconActive : TableGamesIconInactive;
        break;
      case "wl-virtualSportsGames":
        Icon = isActive ? VirtualSportsIconActive : VirtualSportsIconInactive;
        break;
      case "wl-virtualGameGames":
        Icon = VirtualGamesIcon;
        break;
      case "wl-instantWinGames":
        Icon = isActive ? InstantWinIconActive : InstantWinIconInactive;
        break;
      case "wl-bingoGames":
        Icon = BingoIcon;
        break;
      case "wl-shootingGames":
        Icon = isActive ? ShootingIconActive : ShootingIconInactive;
        break;
      case "wl-scratchCardGames":
        Icon = ScratchCardsIcon;
        break;
      case "wl-liveCasinoGames":
        Icon = isActive ? LiveCasinoIconActive : LiveCasinoIconInactive;
        break;
      case "wl-esportsGames":
        Icon = isActive ? EsportsIconActive : EsportsIconInactive;
        break;
      case "wl-CRASH":
        Icon = isActive ? CrashGamesIconActive : CrashGamesIconInactive;
        break;
      case "wl-GAME_SHOW":
        Icon = isActive ? GameShowsIconActive : GameShowsIconInactive;
        break;
      case "wl-lotteryGames":
        Icon = isActive ? LotteryIconActive : LotteryIconInactive;
        break;
      case "wl-SPORTS":
        Icon = isActive ? SportsIconActive : SportsIconInactive;
        break;
      default:
        Icon = HomeIcon;
        break;
    }
    let { locale, sessionId, page } = this.props.match.params;
    let { pathname } = this.props.location;

    return (
      <li
        key={key}
        className={`nav-item ${pathname === "/home"} ${
          page === content.get("rel") ? "selected" : ""
        }`}
      >
        <Link
          className="nav-link text-center"
          to={`/${locale}/${sessionId}/games/${content.get(
            "rel",
          )}/${content.getIn(["links", 1, "rel"])}`}
        >
          <Icon color="rgba(255,204,0,1)" selectedcolor="rgba(255,204,0,1)" />
          <div className="category-name">{content.get("name")}</div>
        </Link>
      </li>
    );
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (
      nextProps.gameLobbyBannerUrls &&
      nextProps.gameLobbyBannerUrls !== this.props.gameLobbyBannerUrls
    ) {
      this.setState({
        bannerUrl: this.setBannerSrc(this.props.match),
      });
    }
    if (nextProps.match && nextProps.match !== this.props.match) {
      this.setState({
        bannerUrl: this.setBannerSrc(nextProps.match),
      });

      if (nextProps.match.params.page !== this.props.match.params.page) {
        this.setState({ isStuck: false });

        const scrollContainer = document.querySelector(".main-content");
        if (scrollContainer) {
          scrollContainer.scrollTop = 0;
        } else {
          window.scrollTo(0, 0);
          document.documentElement.scrollTop = 0;
          document.body.scrollTop = 0;
        }
      }
    }

    if (this.props.isMobile !== nextProps.isMobile) {
      if (nextProps.isMobile) {
        this.scrollTracker.start();
      } else {
        this.scrollTracker.stop();
      }
    }
  }

  render() {
    let { locale, sessionId } = this.props.match.params;
    let bannerUrl = this.setBannerSrc(this.props.match);
    let isMyCasino = this.props.match.params.page === "myQT";
    let { isNavHidden } = this.state;

    return (
      <Fragment>
        {this.props.getPages && this.props.showBanner ? (
          <div
            className={`header-background-holder ${
              isNavHidden ? "nav-hidden" : ""
            }`}
          >
            <div
              data-testid="main-banner"
              className={`header-background ${
                bannerUrl !== undefined ? "withBanner" : ""
              }  ${
                this.props.filtersVisible && !isMyCasino ? "filter-visible" : ""
              }`}
              style={{ backgroundImage: `url(${bannerUrl})` }}
            />
          </div>
        ) : (
          <div
            data-testid="main-banner"
            className={`header-background no-banner 
              ${this.props.isMobile ? "mobile" : "desktop"}
              ${this.props.showMenu ? "show-menu" : ""} 
              ${this.props.showNavigation ? "show-navigation" : ""}`}
          />
        )}
        <div ref={this.sentinelRef} className="sticky-sentinel" />
        <div
          className={`maingamenavigation ${
            !this.props.showNavigation ? "d-none" : ""
          } ${
            this.props.filtersVisible && !isMyCasino
              ? "gamenavigation-filter-visible"
              : ""
          } ${this.state.isStuck ? "is-stuck" : ""} ${
            isNavHidden ? "nav-hidden" : ""
          }`}
        >
          <span className={`gamenavigation`}>
            <ul className="nav justify-content-center">
              {!this.props.myQT &&
                !this.props.contents &&
                [...Array(10)].map((e, key) => (
                  <li className={`nav-item`} key={key}>
                    <span className={"nav-link text-center"}>
                      <MainNavigationSkeleton />
                    </span>
                  </li>
                ))}
              {this.props.myQT && this.props.showNavigation && (
                <li className={`nav-item ${isMyCasino ? "selected" : ""}`}>
                  <Link
                    className="nav-link text-center discover"
                    to={`/${locale}/${sessionId}/categories/${this.props.myQT.get(
                      "rel",
                    )}`}
                  >
                    {isMyCasino ? (
                      <DiscoverIconInactive 
                        data-testid="discover-tab-icon"
                      />
                    ) : (
                      <DiscoverIconActive
                        data-testid="discover-tab-icon"
                      />
                    )}
                    <div data-testid="discover-tab-label" className="category-name">
                      {this.props.myQT.get("name")}
                    </div>
                  </Link>
                </li>
              )}
              {this.props.contents &&
                this.props.showNavigation &&
                this.props.contents.map((content, key) => {
                  return this.getIcon(content, key);
                })}
            </ul>
          </span>
        </div>
      </Fragment>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  let contents;
  let myQT;
  let showNavigation;
  let gameLobbyBannerUrls;
  let getPages;
  let showBanner;
  let showMenu;
  let showCashier;
  let showSwitchDevice;
  let allowMultiGamePlay;
  let displaySearch = state.links.get("search");
  let balance = state.user.get("balance");
  let canToggleProviderLogoOnGames;

  let exitLink = state.profile.get("links").find((link) => {
    return link.get("rel") === "exit";
  });

  let betHistoryLink = state.profile.get("links").find((link) => {
    return link.get("rel") === "service.url";
  });

  let gameRoundHistoryLink = state.profile.get("links").find((link) => {
    return link.get("rel") === "games-round-history.links";
  });

  let continuePlayingLink = state.profile.get("links").find((link) => {
    return link.get("rel") === "categories-home.recentlyplayed";
  });
  try {
    showCashier = state.profile.get("showCashier");
  } catch (err) {}
  try {
    showSwitchDevice = state.profile.get("showSwitchDevice");
  } catch (err) {}

  try {
    allowMultiGamePlay = state.links.get("allowMultiGamePlay");
  } catch (err) {}
  try {
    canToggleProviderLogoOnGames = state.profile.getIn([
      "uiControls",
      "canToggleProviderLogoOnGames",
    ]);
  } catch (err) {}

  try {
    contents = state.pages
      .get("wl-pages")
      .find((page) => {
        return page.get("rel") === "webLobbyMain";
      })
      .get("content");
    gameLobbyBannerUrls = state.links.getIn(["gameLobbyBannerUrls"]);
    getPages = state.links.getIn(["getPages"]);
    showBanner = state.links.getIn(["showBanner"]);
  } catch (err) {}

  try {
    myQT = state.pages.get("wl-pages").find((page) => {
      return page.get("rel") === "myQT";
    });
  } catch (err) {}

  try {
    showNavigation = (myQT && contents) || contents.size > 1 ? true : false;
  } catch (err) {}

  showMenu =
    !isEmpty(state.user.get("displayName")) ||
    state.user.get("showLanguage") ||
    exitLink ||
    betHistoryLink ||
    continuePlayingLink ||
    gameRoundHistoryLink ||
    showCashier ||
    showSwitchDevice ||
    allowMultiGamePlay ||
    displaySearch ||
    balance ||
    canToggleProviderLogoOnGames;

  return {
    showMenu,
    showNavigation,
    isMobile: state.window.get("isMobile"),
    filtersVisible: state.config.get("filtersVisible"),
    contents: contents,
    myQT: myQT,
    gameLobbyBannerUrls,
    width: state.window.get("width"),
    getPages,
    showBanner,
    imageFormat: state.window.get("imageFormat"),
  };
};

const mapDispatchToProps = (dispatch, ownProps) => {
  return bindActionCreators(ActionCreator, dispatch);
};

const mergeProps = (stateProps, dispatchProps, ownProps) => {
  return Object.assign({}, stateProps, ownProps, {
    logout: () => dispatchProps.logout(),
  });
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
  mergeProps,
)(GameNavigation);
